import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { SELF_DELIVERY_EXECUTIVES } from './constants';

const DeliveryExecutiveFields = ({ name, phone, onNameChange, onPhoneChange }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const blurTimeoutRef = useRef(null);

    const filteredExecutives = useMemo(() => {
        const query = name.trim().toLowerCase();
        if (!query) {
            return SELF_DELIVERY_EXECUTIVES;
        }
        return SELF_DELIVERY_EXECUTIVES.filter((executive) =>
            executive.name.toLowerCase().includes(query)
        );
    }, [name]);

    const handleNameFocus = () => {
        if (blurTimeoutRef.current) {
            clearTimeout(blurTimeoutRef.current);
        }
        setShowDropdown(true);
    };

    const handleNameBlur = () => {
        blurTimeoutRef.current = setTimeout(() => setShowDropdown(false), 150);
    };

    const handleSelectExecutive = (executive) => {
        if (blurTimeoutRef.current) {
            clearTimeout(blurTimeoutRef.current);
        }
        onNameChange(executive.name);
        onPhoneChange(executive.phone);
        setShowDropdown(false);
    };

    return (
        <div className="flex gap-[0.9rem]">
            <div className="flex flex-col flex-1 relative">
                <label>Delivery executive name (optional)</label>
                <input
                    type="text"
                    className="w-full"
                    value={name}
                    onChange={(e) => {
                        onNameChange(e.target.value);
                        setShowDropdown(true);
                    }}
                    onFocus={handleNameFocus}
                    onBlur={handleNameBlur}
                    placeholder="Search or enter name"
                    autoComplete="off"
                />
                {showDropdown && filteredExecutives.length > 0 && (
                    <div className="absolute z-[300] left-0 right-0 top-full mt-1 rounded-lg border border-gray-200 bg-white-50 shadow-lg overflow-hidden" style={{ backgroundColor: '#ffffff' }}>
                        <ul className="max-h-40 overflow-y-auto bg-white-50 list-none m-0 p-0">
                            {filteredExecutives.map((executive) => (
                                <li
                                    key={executive.name}
                                    className="cursor-pointer px-3 py-2 hover:bg-gray-100 text-sm bg-white-50"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => handleSelectExecutive(executive)}
                                >
                                    <span className="font-medium">{executive.name}</span>
                                    <span className="text-gray-500 ml-2">{executive.phone}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <div className="flex flex-col flex-1">
                <label>Delivery executive phone (optional)</label>
                <input
                    type="text"
                    className="w-full"
                    value={phone}
                    onChange={(e) => onPhoneChange(e.target.value)}
                    placeholder="10-digit mobile number"
                />
            </div>
        </div>
    );
};

DeliveryExecutiveFields.propTypes = {
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    onPhoneChange: PropTypes.func.isRequired,
};

export default DeliveryExecutiveFields;
